import state from './moduleMapPlotTargetState.js'
import mutations from './moduleMapPlotTargetMutations.js'
import actions from './moduleMapPlotTargetActions.js'
import getters from './moduleMapPlotTargetGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
